import { MenuItem, MenuGroup } from '@chakra-ui/react';

import {
  SFArchiveFilled,
  SFArchiveOutlined,
  SFCopyIcon,
  SFSaveIconFilled,
  SFSaveIconOutlined
} from '@assets/icons';
import { useCopyToClipboard } from '@util/hooks';

export default function ReskinSummaryCardMenu({
  meeting,
  card,
  showCardActions = true,
  onCardActionClick,
  additionalCardMenuItems,
  children
}) {
  const copyToClipboard = useCopyToClipboard();

  const sourceDataLink = `${card?.source === 'Meeting' ? 'meeting' : 'cards'}/${card?.id}`;
  const link = meeting ? `meeting/${meeting?.id}` : sourceDataLink;

  return (
    <>
      {!!card && showCardActions && (
        <MenuGroup title='Summary Options'>
          <MenuItem
            icon={<SFCopyIcon w={5} />}
            onClick={() => copyToClipboard(`${window?.location?.origin}/${link}`)}
          >
            Copy Link
          </MenuItem>
          <MenuItem
            icon={card?.preferred ? <SFSaveIconFilled w={5} /> : <SFSaveIconOutlined w={5} />}
            onClick={() => onCardActionClick('save', !card?.preferred, card)}
          >
            {card?.preferred ? 'Unsave' : 'Save'}
          </MenuItem>
          <MenuItem
            icon={card?.archived ? <SFArchiveFilled w={5} /> : <SFArchiveOutlined w={5} />}
            onClick={() => onCardActionClick('archive', !card?.archived, card)}
          >
            {card?.archived ? 'Unarchive' : 'Archive'}
          </MenuItem>
          {additionalCardMenuItems}
        </MenuGroup>
      )}
      {children}
    </>
  );
}
